import { StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';

export const SEStyles = StyleSheet.create({
  container: {
    background: 'white',
    height: '100%',
    borderRadius: AppTheme.pagePadding,
  },
  content: {
    padding: '16px 16px 16px 16px',
  },
  heading: {
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  editButton: {
    color: AppTheme.primaryColor,
    padding: 0,
    minWidth: 'auto',
    ':hover': {
      background: 'none'
    }
  },
  stepFormTitle: {
    fontSize: 18,
    lineHeight: '33px',
    fontWeight: 'normal',
    margin: 0,
    marginBottom: 4,
  },
  label: {
    fontSize: 12,
    color: 'grey', //'#36454f',
    marginBottom: 4,
  },
  value: {
    margin: 0,
    fontSize: 14,
    color: 'black',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
})



// WEBPACK FOOTER //
// ./src/common/components/SubEntity/SEStyles.js